import { render, staticRenderFns } from "./produto-nao-encontrado.html?vue&type=template&id=5dc79956&scoped=true&"
import script from "./produto-nao-encontrado.vue?vue&type=script&lang=js&"
export * from "./produto-nao-encontrado.vue?vue&type=script&lang=js&"
import style0 from "./produto-nao-encontrado.less?vue&type=style&index=0&id=5dc79956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc79956",
  null
  
)

export default component.exports